import './styles.css';

function Home() {
  return (
    <div className='home'>
      <div className="banner-text">
          <h1>Hair Salon</h1>
          <p>Unleash Hair's True Potential</p>
          <div className="banner-btn">
              <a href="#footer"><span></span>Find Out</a>
              <a href="#feature"><span></span>Read More</a>
          </div>    
      </div>
    </div>
  );
}

export default Home;